import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import { getToken, setToken } from '@/libs/cookie-storage'
import { getPassport } from '@/libs/passport'
import isEmpty from 'lodash/isEmpty'
import {varConfig, getSearchParams} from '@/utils'
import Vue from 'vue'
import { Toast } from 'vant'

Vue.use(Toast)

// 创建axios实例
const service = axios.create({
  baseURL: varConfig.banmaApi, // api的base_url
  timeout: 50000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (config.data) {
    config.data = qs.stringify(config.data)
  }
  config.params = config.params || {}
  // 处理app中URL中passport参数
  const query = getSearchParams()
  const token = getToken()
  if (token) {
    config.params.passport = getToken()
  } else if (query && query.passport) {
    setToken(query.passport)
    config.params.passport = query.passport
  }
  // get method, params object to url query string
  // avoid param value contains url bug
  config.url += isEmpty(config.params) ? '' : ('?' + qs.stringify(config.params))
  config.params = null
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
  /**
  * code为非20000是抛错 可结合自己业务进行修改
  */
    const res = response.data
    if (res.error) {
      const error = res.messages.error
      let message = ''
      if (error.code === 'login_required' || error.code === 'login_account_expired' || error.code === 'login_account_denied') {
        store.dispatch('LogOut').then(() => {
          // location.reload()// 为了重新实例化vue-router对象 避免bug
          getPassport()
        })
        message = error.message
      } else {
        if (res.code === 500 && error.code === 'internal_error') {
          message = '内部错误：' + error.message
        } else {
          message = error.message
        }
        Toast(message)
      }
      console.log(message)
      return Promise.resolve(false)
    } else {
      return res.messages
    }
  },
  error => {
    console.log(error)// for debug
    Toast(error.message)
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js